import React from 'react'
import { IsLoggedProvider } from 'signup/hooks/context/IsLoggedContext.js'

import HeaderProviderMethods from 'reactSite/Header/providers/HeaderProviderMethods'

import { Routes } from './routes'

const App = () => (
  <HeaderProviderMethods>
    <IsLoggedProvider>
      <Routes />
    </IsLoggedProvider>
  </HeaderProviderMethods>
)

export default App
